import Container from "react-bootstrap/Container";
import FormSection from "../../components/formsection";
import Button from "react-bootstrap/Button";
import { Row, Col, Card } from "react-bootstrap";
import Faq from "../../components/Faq";
import "../../styles/dualEducation.css";
import "../../styles/sliderCalculator.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";

export default function CorporateAccountOptimize() {
  const [monthlyFees, setMonthlyFees] = useState(100_000); // Ft

  const estimatedSavings = monthlyFees * 0.4; // 40% average saving
  const yearlySavings = estimatedSavings * 12;
  const successFee = yearlySavings * 0.35;
  const netSavings = yearlySavings - successFee;

  return (
    <>
      <Container className="px-1 hero mx-md-auto">
        <span className="badge">
          DÍJMENTES ÁTVILÁGÍTÁS • SIKERDÍJAS KONSTRUKCIÓ
        </span>

        <h1 className="title">
          Számlavezetési költségek <br />
          <span style={{ color: "#c7d2fe" }}>optimalizálása</span>
        </h1>

        <p className="subtitle">
          Akár <strong>40-60%-kal</strong> csökkenthetjük céged éves banki
          költségeit. Szakértőink átvilágítják jelenlegi kondícióidat és
          megkeresik a piacon elérhető legkedvezőbb ajánlatokat –{" "}
          <strong>tiszta sikerdíjas alapon.</strong>
          <br />
          <span className="fw-bold">
            Számold ki, mennyit takaríthat meg a vállalkozásod!
          </span>
        </p>

        <div className="cta">
          <Button href="#calculation" className="btn btn-primary">
            Számolok
          </Button>

          <Button href="#leadform" className="btn btn-secondary">
            Ingyenes elemzést kérek
          </Button>
        </div>
      </Container>

      <Container>
        <section className="section">
          <Row className="g-3">
            <Col md={3}>
              <Card className="card">
                <div className="kpi">-50%</div>
                <div className="muted">Átlagos költségcsökkenés</div>
              </Card>
            </Col>

            <Col md={3}>
              <Card className="card">
                <div className="kpi">12+ Bank</div>
                <div className="muted">Teljes piaci összehasonlítás</div>
              </Card>
            </Col>

            <Col md={3}>
              <Card className="card">
                <div className="kpi">Sikerdíj</div>
                <div className="muted">Csak megtakarítás esetén fizetsz</div>
              </Card>
            </Col>

            <Col md={3}>
              <Card className="card">
                <div className="kpi">24 óra</div>
                <div className="muted">Garantált elemzési idő</div>
              </Card>
            </Col>
          </Row>
        </section>

        <section id="miert" className="section">
          <h2 className="h2">Mit vizsgálunk át?</h2>
          <p className="lead">
            Nem csak a számlavezetési díjat nézzük. A teljes banki
            költségszerkezetet optimalizáljuk.
          </p>

          <Row className="g-3">
            <Col md={6}>
              <Card className="card h-100">
                <h3>Tranzakciós költségek</h3>
                <ul className="list check-list">
                  <li>
                    <FontAwesomeIcon icon={faCheck} />
                    Belföldi és külföldi utalások díjai
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} />
                    Csoportos beszedések és állandó átutalások
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} />
                    Készpénzfelvét és befizetés költségei
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} />
                    VIBER és azonnali átutalások optimalizálása
                  </li>
                </ul>
              </Card>
            </Col>

            <Col md={6}>
              <Card className="card h-100">
                <h3>Egyéb banki szolgáltatások</h3>
                <ul className="list check-list">
                  <li>
                    <FontAwesomeIcon icon={faCheck} />
                    Bankkártyák éves és tranzakciós díjai
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} />
                    POS terminál forgalmi jutalékok
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} />
                    Devizaváltási (FX) árrések és kondíciók
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} />
                    Számlavezetési és csomagdíjak
                  </li>
                </ul>
              </Card>
            </Col>
          </Row>
        </section>

        <Container id="calculation">
          <h2 className="h2 mt-5">Megtakarítási kalkulátor</h2>
          <section className="slider-calculator section p-0">
            <div className="calculator-wrapper">
              <h3 className="h4">
                Jelenlegi havi bankköltség:{" "}
                <span className="number">{monthlyFees.toLocaleString()}</span>{" "}
                Ft
              </h3>

              <input
                type="range"
                min={20_000}
                max={2_000_000}
                step={10_000}
                value={monthlyFees}
                onChange={(e) => setMonthlyFees(Number(e.target.value))}
                className="slider"
              />

              <div className="revenue-block">
                <div className="row">
                  <Col md={4}>
                    <div className="revenue-text">
                      Éves bruttó megtakarítás:
                    </div>
                    <div className="revenue-value">
                      <strong>
                        {Math.round(yearlySavings).toLocaleString()} Ft
                      </strong>
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="revenue-text">Sikerdíj (35%):</div>
                    <div className="revenue-value" style={{ color: "#f87171" }}>
                      <strong>
                        {Math.round(successFee).toLocaleString()} Ft
                      </strong>
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="revenue-text">Nettó megtakarításod:</div>
                    <div className="revenue-value" style={{ color: "#34d399" }}>
                      <strong>
                        {Math.round(netSavings).toLocaleString()} Ft
                      </strong>
                    </div>
                  </Col>
                </div>
                <div className="disclaimer mt-3">
                  *A kalkuláció statisztikai átlagokon alapul (40%-os
                  megtakarítás). A sikerdíj a ténylegesen elért első éves
                  megtakarítás 35%-a.
                </div>
              </div>
            </div>
            <div className="text-center mt-5">
              <Button href="#leadform" className="btn btn-primary">
                Kérem a részletes elemzést
              </Button>
            </div>
          </section>
        </Container>

        <section id="folyamat" className="section">
          <h2 className="h2">Hogyan dolgozunk?</h2>
          <div className="steps-container mt-4">
            <Row className="g-4">
              <Col md={3} xs={12} className="text-center">
                <div className="step-number">1</div>
                <p className="fw-bold">Adatgyűjtés</p>
                <p className="small">Kérünk egy havi bankszámlakivonatot</p>
              </Col>
              <Col md={3} xs={12} className="text-center">
                <div className="step-number">2</div>
                <p className="fw-bold">Elemzés</p>
                <p className="small">Átvilágítjuk a jelenlegi költségeidet</p>
              </Col>
              <Col md={3} xs={12} className="text-center">
                <div className="step-number">3</div>
                <p className="fw-bold">Összehasonlítás</p>
                <p className="small">Versenyeztetjük a bankokat</p>
              </Col>
              <Col md={3} xs={12} className="text-center">
                <div className="step-number">4</div>
                <p className="fw-bold">Megvalósítás</p>
                <p className="small">
                  Segítünk a váltásban vagy újratárgyalásban
                </p>
              </Col>
            </Row>
          </div>
        </section>

        <Container id="leadform">
          <h2 className="h2">Ingyenes költségátvilágítás</h2>
          <p className="lead small">
            Küldd el érdeklődésed, és szakértőnk 24 órán belül felveszi veled a
            kapcsolatot!
          </p>
          <Row>
            <Col md={4}>
              <FormSection formType="Számlaoptimalizálás" />
            </Col>
            <Col md={7} className="ms-md-5 ps-md-5 pt-2">
              <ul className="list check-list mt-3">
                <li className="mb-3">
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="mb-2"
                    style={{ fontSize: "20px" }}
                  />
                  <h4>Díjmentes átvilágítás</h4>
                </li>
                <li className="mb-3">
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="mb-2"
                    style={{ fontSize: "20px" }}
                  />
                  <h4>Garantált megtakarítási javaslat</h4>
                </li>
                <li className="mb-3">
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="mb-2"
                    style={{ fontSize: "20px" }}
                  />
                  <h4>Teljes körű ügyintézési támogatás</h4>
                </li>
                <li className="mb-3">
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="mb-2"
                    style={{ fontSize: "20px" }}
                  />
                  <h4>Csak elért eredmény után fizetsz</h4>
                </li>
              </ul>
            </Col>
          </Row>
        </Container>

        <section id="faq" className="section pb-0">
          <h2 className="h2">Gyakran ismételt kérdések</h2>

          <Faq
            categories={[
              {
                key: "altalanos",
                label: "Általános",
                items: [
                  {
                    question: "Mennyibe kerül a szolgáltatás?",
                    answer:
                      "A szolgáltatásunk sikerdíjas alapú. Ez azt jelenti, hogy csak akkor kell fizetned, ha ténylegesen megtakarítást érünk el számodra. A díjunk az első évben realizált megtakarítás 35%-a. Az átvilágítás és a tanácsadás továbbra is díjmentes.",
                  },
                  {
                    question: "Milyen adatokat kell megadnom?",
                    answer:
                      "Egy reprezentatív havi bankszámlakivonatra van szükségünk (anonimizálva is jó), hogy lássuk a tranzakciók típusát, volumenét és a jelenlegi díjakat.",
                  },
                  {
                    question: "Kötelező a bankváltás?",
                    answer:
                      "Nem minden esetben. Gyakran előfordul, hogy a meglévő banknál is elérhető kedvezőbb csomag, vagy egyedi alkut tudunk kötni a jelenlegi pénzintézeteddel a piaci ajánlatok ismeretében.",
                  },
                ],
              },
            ]}
          />
        </section>
      </Container>
    </>
  );
}
